import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      ligh: "#4dabf5",
      main: "#2196f3",
      dark: "#1769aa",
    },
    secondary: {
      ligh: "#ff5eca",
      main: "#ff0099",
      dark: "#c6006b",
    },
  },
});
